import { render, staticRenderFns } from "./ParametreNew.vue?vue&type=template&id=898ca36a&"
import script from "./ParametreNew.vue?vue&type=script&lang=js&"
export * from "./ParametreNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('898ca36a')) {
      api.createRecord('898ca36a', component.options)
    } else {
      api.reload('898ca36a', component.options)
    }
    module.hot.accept("./ParametreNew.vue?vue&type=template&id=898ca36a&", function () {
      api.rerender('898ca36a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/parametre/ParametreNew.vue"
export default component.exports